(function() {
    var FORM_ID = "_rsi-cod-form-modal-form",
        ENDPOINT = "https://api-new.3alla9ni.net/webhook/shopify/quick-form-abandoned",
        hasSubmitted = !1,
        sentKeys = {},
        LS_PREFIX = "__RSI_ABANDON_SENT__";

    function safeLSGet(key) {
        try {
            return window.localStorage.getItem(key)
        } catch (e) {
            return null
        }
    }

    function safeLSSet(key, val) {
        try {
            window.localStorage.setItem(key, val)
        } catch (e) {}
    }

    function getShopifyDomain() {
        try {
            if (window.Shopify && typeof window.Shopify.shop == "string" && window.Shopify.shop.trim() !== "") return window.Shopify.shop.trim()
        } catch (e) {}
        return null
    }

    function getFormEl() {
        return document.getElementById(FORM_ID)
    }

    function formToObject(formEl) {
        var fd = new FormData(formEl),
            obj = {};
        return fd.forEach(function(v, k) {
            obj[k] !== void 0 ? (Array.isArray(obj[k]) || (obj[k] = [obj[k]]), obj[k].push(v)) : obj[k] = v
        }), obj
    }

    function shouldSend(formObj) {
        var phone = (formObj.phone || formObj.telephone || "").toString().trim();
        return !!phone
    }

    function normalizePhone(raw) {
        return (raw || "").toString().replace(/[^\d+]/g, "").trim()
    }

    function isPhoneComplete(raw) {
        var p = normalizePhone(raw),
            digits = p.replace(/[^\d]/g, "");
        return !!(/^\+216\d{8}$/.test(p) || /^\d{8}$/.test(digits))
    }

    function getPhoneFromData(data) {
        return data && (data.phone || data.telephone || data.tel || data.mobile || "") || ""
    }

    function extractProductsFromModal() {
        var $form = window.jQuery ? window.jQuery("#" + FORM_ID) : null;
        if (!$form || !$form.length) return [];
        var items = [];
        if ($form.find("._rsi-modal-line-item").each(function() {
                var $it = window.jQuery(this),
                    variantId = $it.attr("data-line-item-variant-id") || null,
                    title = ($it.find("a._rsi-modal-line-item-title").text() || "").trim() || null,
                    qText = ($it.find("._rsi-modal-line-item-quantity").text() || "").trim(),
                    quantity = parseInt(qText, 10);
                (!quantity || quantity < 1) && (quantity = 1);
                var price = ($it.find("._rsi-modal-line-item-final-price").text() || "").trim() || null,
                    img = $it.find("img._rsi-modal-line-item-image").attr("src") || null;
                items.push({
                    variant_id: variantId,
                    product_id: null,
                    title: title,
                    quantity: quantity,
                    price: price,
                    compare_at_price: null,
                    image: img
                })
            }), !items.length) {
            var formEl = getFormEl();
            if (formEl) {
                var data = formToObject(formEl);
                items = extractProductsFromHiddenInputs(data)
            }
        }
        return items
    }

    function extractProductsFromHiddenInputs(data) {
        var variants = {},
            qtys = {};
        Object.keys(data || {}).forEach(function(k) {
            var v = data[k];
            if (typeof k == "string") {
                if (k.indexOf("item_variant_id[") === 0) {
                    var inner = k.substring(16, k.length - 1);
                    variants[inner] = v
                }
                if (k.indexOf("item_quantity[") === 0) {
                    var inner2 = k.substring(14, k.length - 1);
                    qtys[inner2] = v
                }
            }
        });
        var out = [];
        return Object.keys(variants).forEach(function(innerKey) {
            var variantId = variants[innerKey],
                q = parseInt(qtys[innerKey] || "1", 10);
            (!q || q < 1) && (q = 1), out.push({
                variant_id: variantId ? String(variantId) : null,
                product_id: null,
                title: null,
                quantity: q,
                price: null,
                compare_at_price: null,
                image: null
            })
        }), out
    }

    function buildPayload(formEl, reason) {
        var data = formToObject(formEl);
        return {
            shopify_domain: getShopifyDomain(),
            event: "form_abandoned",
            reason: reason || "phone_filled",
            occurred_at: new Date().toISOString(),
            page_url: window.location.href,
            referrer: document.referrer || null,
            user_agent: navigator.userAgent,
            form_id: FORM_ID,
            abandoned_order_id: data.abandoned_order_id || null,
            country_code: data.country_code || null,
            cart_token: data.cart_token || null,
            data: data,
            products: extractProductsFromModal()
        }
    }

    function buildDedupKey(payload) {
        var shop = payload.shopify_domain || "unknown_shop",
            cart = payload.cart_token || payload.abandoned_order_id || "no_cart",
            phone = normalizePhone(getPhoneFromData(payload.data));
        return [LS_PREFIX, shop, cart, phone].join("|")
    }

    function sendAbandon(payload) {
        var dkey = buildDedupKey(payload);
        if (!sentKeys[dkey]) {
            if (safeLSGet(dkey) === "1") {
                sentKeys[dkey] = !0;
                return
            }
            sentKeys[dkey] = !0, safeLSSet(dkey, "1");
            var body = JSON.stringify(payload);
            if (navigator.sendBeacon) try {
                var blob = new Blob([body], {
                    type: "text/plain;charset=UTF-8"
                });
                navigator.sendBeacon(ENDPOINT, blob);
                return
            } catch (e) {}
            try {
                fetch(ENDPOINT, {
                    method: "POST",
                    mode: "no-cors",
                    keepalive: !0,
                    headers: {
                        "Content-Type": "text/plain;charset=UTF-8"
                    },
                    body: body
                }).catch(function() {})
            } catch (e) {}
        }
    }

    function trySend(reason) {
        var formEl = getFormEl();
        if (formEl && !hasSubmitted) {
            var payload = buildPayload(formEl, reason),
                phone = getPhoneFromData(payload.data);
            isPhoneComplete(phone) && shouldSend(payload.data) && sendAbandon(payload)
        }
    }
    var __phoneDebounceT = null;

    function hookPhoneWatcher() {
        var $ = window.jQuery;
        if ($) {
            var sel = "#" + FORM_ID + " input[name='phone'], #" + FORM_ID + " input[name='telephone'], #" + FORM_ID + " input[name='tel'], #" + FORM_ID + " input[name='mobile'], #" + FORM_ID + " input[type='tel']";
            $(document).on("input change blur", sel, function() {
                __phoneDebounceT && clearTimeout(__phoneDebounceT), __phoneDebounceT = setTimeout(function() {
                    trySend("phone_filled")
                }, 400)
            })
        }
    }

    function init() {
        window.jQuery(document).on("submit", "#" + FORM_ID, function() {
            hasSubmitted = !0
        }), hookPhoneWatcher()
    }

    function waitForJQAndInit() {
        var maxMs = 2e4,
            step = 200,
            spent = 0,
            t = setInterval(function() {
                typeof window.jQuery == "function" ? (clearInterval(t), init()) : (spent += step, spent >= maxMs && clearInterval(t))
            }, step)
    }
    waitForJQAndInit(), window.__RSI_RESET_SESSION_SENT = function() {
        sentKeys = {}, console.log("[RSI] sentKeys reset (session/page only)")
    }, window.__RSI_SIMULATE_PHONE_FILLED = function() {
        trySend("test_simulate_phone_filled")
    }, window.__RSI_CLEAR_DEDUP = function() {
        try {
            for (var keys = [], i = 0; i < localStorage.length; i++) {
                var k = localStorage.key(i);
                k && k.indexOf(LS_PREFIX) === 0 && keys.push(k)
            }
            keys.forEach(function(k2) {
                localStorage.removeItem(k2)
            }), console.log("[RSI] cleared dedup keys:", keys.length)
        } catch (e) {
            console.log("[RSI] failed to clear dedup keys")
        }
    }
})();
